var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoArrowUpGray16(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1209_17689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1209_17689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.46666 10.3C4.34444 10.1778 4.28333 10.0223 4.28333 9.83337C4.28333 9.64448 4.34444 9.48892 4.46666 9.3667L7.53333 6.30003C7.59999 6.23337 7.67221 6.18614 7.74999 6.15837C7.82777 6.13059 7.9111 6.1167 7.99999 6.1167C8.08888 6.1167 8.17499 6.13337 8.25833 6.1667C8.34166 6.20003 8.4111 6.24448 8.46666 6.30003L11.5333 9.3667C11.6555 9.48892 11.7167 9.64448 11.7167 9.83337C11.7167 10.0223 11.6555 10.1778 11.5333 10.3C11.4111 10.4223 11.2555 10.4834 11.0667 10.4834C10.8778 10.4834 10.7222 10.4223 10.6 10.3L7.99999 7.70003L5.39999 10.3C5.27777 10.4223 5.12221 10.4834 4.93333 10.4834C4.74444 10.4834 4.58888 10.4223 4.46666 10.3Z",
    fill: "#BDBDBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoArrowUpGray16);
export default __webpack_public_path__ + "static/media/ico_arrow_up_gray_16.320c4bfd37395964102325584e4c6e7b.svg";
export { ForwardRef as ReactComponent };